import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["src"];
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.regexp.to-string.js";
import React from 'react';
import styled from 'styled-components';
import { fillParent } from 'styles/mixins';
import { useLocation } from 'react-router';
var Iframe = styled.iframe.withConfig({
  displayName: "PDFViewer__Iframe",
  componentId: "sc-s65m1-0"
})(["", " width:100%;height:100%;"], fillParent);
function PDFViewer(_ref) {
  var src = _ref.src,
    props = _objectWithoutProperties(_ref, _excluded);
  var location = useLocation();
  var hashParams = new URLSearchParams(location.hash.replace(/^#/, ''));

  // Rename the position to 'page' for the PDF viewer
  if (hashParams.has('position')) {
    hashParams.set('page', hashParams.get('position'));
    hashParams.delete('position');
  }
  var hash = hashParams.toString();

  // Indicate that the response should wrap the redirect with a hosted PDF Player
  src += "?wrap".concat(hash ? "#".concat(hash) : '');
  return /*#__PURE__*/React.createElement(Iframe, _extends({
    src: src
  }, props));
}
export default PDFViewer;